import { SVGProps } from 'react';

const SquaresScaleSmallIntersectTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_308_74)">
            <path
                d="M1.33301 12.5334C1.33301 13.2801 1.33301 13.6535 1.47833 13.9387C1.60616 14.1896 1.81014 14.3935 2.06102 14.5214C2.34624 14.6667 2.7196 14.6667 3.46634 14.6667H8.53301C9.27974 14.6667 9.65311 14.6667 9.93833 14.5214C10.1892 14.3935 10.3932 14.1896 10.521 13.9387C10.6663 13.6535 10.6663 13.2801 10.6663 12.5334V7.46669C10.6663 6.71995 10.6663 6.34658 10.521 6.06137C10.3932 5.81048 10.1892 5.60651 9.93833 5.47868C9.65311 5.33335 9.27974 5.33335 8.53301 5.33335H3.46634C2.7196 5.33335 2.34624 5.33335 2.06102 5.47868C1.81014 5.60651 1.60616 5.81048 1.47833 6.06137C1.33301 6.34658 1.33301 6.71995 1.33301 7.46669L1.33301 12.5334Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.33301 8.53335C5.33301 9.28009 5.33301 9.65346 5.47833 9.93867C5.60616 10.1896 5.81014 10.3935 6.06102 10.5214C6.34624 10.6667 6.7196 10.6667 7.46634 10.6667L12.533 10.6667C13.2797 10.6667 13.6531 10.6667 13.9383 10.5214C14.1892 10.3935 14.3932 10.1896 14.521 9.93867C14.6663 9.65346 14.6663 9.28009 14.6663 8.53335L14.6663 3.46669C14.6663 2.71995 14.6663 2.34658 14.521 2.06137C14.3932 1.81048 14.1892 1.60651 13.9383 1.47868C13.6531 1.33335 13.2797 1.33335 12.533 1.33335L7.46634 1.33335C6.7196 1.33335 6.34624 1.33335 6.06102 1.47868C5.81014 1.60651 5.60616 1.81048 5.47833 2.06137C5.33301 2.34658 5.33301 2.71995 5.33301 3.46669L5.33301 8.53335Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_308_74">
                <rect width={16} height={16} fill="white" transform="matrix(1 0 0 -1 0 16)" />
            </clipPath>
        </defs>
    </svg>
);
export default SquaresScaleSmallIntersectTrue;
